module.exports = __webpack_public_path__ + "img/Icon (2).9991b48a.svg";